import { Input } from 'reactstrap'

export default function DateRangeInput({ label, name, handleInputChange, defaultValueTo, defaultValueFrom }) {
  console.log(`DateRangeInput rendered: ${label}`)

  const style = {
    display: 'inline-block',
    width: 'auto',
    marginRight: '5px',
    marginLeft: '5px'
  }

  return (
    <tr>
      <td style={{ verticalAlign: 'middle' }}><b>{label}</b></td>
      <td>
        <b>From</b><Input style={style} type='date' name={`${name}From`} onChange={handleInputChange} defaultValue={defaultValueFrom} />
        <b>To</b><Input style={style} type='date' name={`${name}To`} onChange={handleInputChange} defaultValue={defaultValueTo} />
      </td>
    </tr>
  )
}
